import ScrollMagic from 'scrollmagic';

export default new ScrollMagic.Controller();
